import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAppSelector } from '../../hooks/useAppSelector'

interface IProps {
	children: React.ReactNode
}

const RequireAuth: React.FC<IProps> = ({ children }) => {
	const { isAuth } = useAppSelector((state) => state.auth)

	if (!isAuth) {
		return <Navigate to="/sign-in" />
	}

	return <>{children}</>
}

export default RequireAuth
